import { noCase } from 'change-case';
// @mui
import {
  Box,
  List,
  Badge,
  Button,
  Avatar,
  Tooltip,
  Divider,
  IconButton,
  Typography,
  ListItemText,
  ListSubheader,
  ListItemAvatar,
  ListItemButton,
  BadgeProps,
  styled,
  MenuItem,
} from '@mui/material';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// utils
import { fToNow } from '../../../utils/formatTime';
// _mock_
import { _notifications } from '../../../_mock';
// components
import Iconify from '../../../components/Iconify';
import Scrollbar from '../../../components/Scrollbar';
import MenuPopover from '../../../components/MenuPopover';
import { IconButtonAnimate } from '../../../components/animate';
import { useEffect, useState } from 'react';
import { useStore } from 'src/stores/store';
import { baseUrl } from 'src/api/baseUrl';
import { themeMode } from 'src/utils/general';
import useLocales from 'src/hooks/useLocales';
import Loader from 'src/components/loader/Loader';
import { TableMoreMenu } from 'src/components/table';
// ----------------------------------------------------------------------

export default function NotificationsPopover() {
  const { translate } = useLocales();
  const { notificationStore } = useStore();
  const { loadNotification, notificationList, totalRecord } = notificationStore;
  const [notifications, setNotifications] = useState(_notifications);
  const [showMarkAsRead, setShowMarkAsRead] = useState(true);
  const [selected, setSelected] = useState('all');
  const totalUnRead = notifications.filter((item) => item.isUnRead === true).length;

  const [open, setOpen] = useState<HTMLElement | null>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setOpen(event.currentTarget);
  };
  const [loading, setLoading] = useState(false);

  const [pageSize, setPageSize] = useState(5);

  const handleClose = () => {
    setOpen(null);
  };
  const LoadMore = () => {
    setPageSize((prevPageSize) => prevPageSize + 5);
    setTimeout(() => {
      setLoading(true);
    }, 1000);
  };
  useEffect(() => {
    if (loading) {
      loadNotification({ pageIndex: 0, pageSize: pageSize }).then(() => {
        setLoading(false);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);
  const handleSelect = (value: any) => {
    setSelected(value);
    if (value === 'all') {
      setShowMarkAsRead(true);
    } else {
      setShowMarkAsRead(false);
    }
  };
  const handleMarkAllAsRead = () => {
    setNotifications(
      notifications.map((notification) => ({
        ...notification,
        isUnRead: false,
      }))
    );
  };

  // const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
  //   '& .MuiBadge-badge': {
  //     right: -3,
  //     top: 13,
  //     border: `2px solid ${theme.palette.background.paper}`,
  //     padding: '0 4px',
  //   },
  // }));

  return (
    <>
      <IconButtonAnimate>
        <Badge badgeContent={totalRecord} color={'error'} onClick={handleOpen}>
          <Iconify
            color={open ? 'primary' : 'default'}
            sx={{ color: themeMode() === 'light' ? 'darkgray' : 'lightgray' }}
            icon="eva:bell-fill"
            width={20}
            height={20}
          />
        </Badge>
      </IconButtonAnimate>
      {/* <IconButtonAnimate
        color={open ? 'primary' : 'default'}
        onClick={handleOpen}
        sx={{ width: 40, height: 40 }}
      >
        
      </IconButtonAnimate> */}

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{ width: 360, p: 0, mt: 2, ml: 0.75 }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', py: 2, px: 2.5 }}>
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="subtitle1">{translate('Notifications.Notifications')}</Typography>
          </Box>
        </Box>
        <Divider sx={{ borderStyle: 'dashed' }} />
        <Button
          sx={{
            borderRadius: '30px 30px 30px 30px',
            mt: 1,
            ml: 1,
            // backgroundColor: selectedButton === true ? 'red' : undefined,
            border: selected === 'all' ? 'solid 2px' : 'transparent',
            bgcolor: selected === 'all' ? 'transparent' : 'background.neutral',
          }}
          // onClick={() => setShowMarkAsRead(true)}
          onClick={() => handleSelect('all')}
        >
          {translate('Notifications.All')}
        </Button>
        <Button
          sx={{
            borderRadius: '30px 30px 30px 30px',
            mt: 1,
            ml: 1,
            // backgroundColor: selectedButton === true ? 'red' : undefined,
            border: selected === 'unread' ? 'solid 2px' : 'transparent',
            bgcolor: selected === 'unread' ? 'transparent' : 'background.neutral',
          }}
          // onClick={() => setShowMarkAsRead(false)}
          onClick={() => handleSelect('unread')}
        >
          {translate('Notifications.Unread')}
        </Button>
        {loading ? (
          <Loader />
        ) : (
          <Scrollbar sx={{ height: { xs: 340, sm: 'auto', lg: 550 } }}>
            <List>
              {showMarkAsRead === true
                ? notificationList.map((notification) => (
                    <NotificationItem key={notification.id} notification={notification} />
                  ))
                : notificationList
                    .filter((res) => res.isRead === showMarkAsRead)
                    .map((notification) => (
                      <NotificationItem key={notification.id} notification={notification} />
                    ))}
            </List>
          </Scrollbar>
        )}
        <Divider sx={{ borderStyle: 'dashed' }} />

        <Box sx={{ p: 1 }}>
          <Button fullWidth disableRipple onClick={() => LoadMore()}>
            {translate('Notifications.ViewMore')}
          </Button>
        </Box>
      </MenuPopover>
    </>
  );
}

// ----------------------------------------------------------------------

type NotificationItemProps = {
  id: number;
  trackingId: number;
  notificationMessageId: number;
  applicationId?: number;
  title: string;
  controllerLink?: string;
  message: string;
  fromUserName: string | null;
  fromUserPhotoPath: string;
  isRead: boolean;
  createdOn: string;
  trackingNumber: string;
  remarks: string;
};

function NotificationItem({ notification }: { notification: NotificationItemProps }) {
  const { translate } = useLocales();
  const [openMenu, setOpenMenuActions] = useState<HTMLElement | null>(null);
  const isRead = true;
  // const [showToggleRead, setShowToggleRead] = useState(true);

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setOpenMenuActions(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpenMenuActions(null);
  };

  const { notificationStore } = useStore();
  const { readNotification } = notificationStore;
  const { avatar, title } = renderContent(notification);
  const navigate = useNavigate();
  const setTrackingLocalStorage = (trackingID?: number) => {
    if (trackingID !== undefined || trackingID !== 0) {
      window.localStorage.setItem('hilightID', trackingID!.toString());
    } else window.localStorage.removeItem('hilightID');
  };
  const readNotifications = (
    id: number,
    system?: number,
    action?: string,
    trackingId?: number,
    notificationType?: number
  ) => {
    readNotification(id);
    if (system === 4 && action === 'ContractController') {
      setTrackingLocalStorage(trackingId);
      if (notificationType === 4) {
        navigate(PATH_DASHBOARD.ContractInfo.list);
      } else {
        navigate(PATH_DASHBOARD.ContractInfo.list);
      }
    } else if (system === 4 && action === 'ContractController') {
      setTrackingLocalStorage(trackingId);
      navigate(PATH_DASHBOARD.ContractInfo.list);
    }
  };

  return (
    <>
      <span>
        <ListItemButton
          sx={{
            // borderBottom: 1,
            borderRadius: '14px 14px 14px 14px',
            py: 1,
            px: 1,
            mb: '10px',
            mr: '3%',
            ml: '3%',
            ...(notification.isRead === false && {
              bgcolor: 'action.selected',
            }),
          }}
        >
          <ListItemAvatar>
            <Avatar sx={{ bgcolor: 'background.neutral' }}>{avatar}</Avatar>
          </ListItemAvatar>
          <ListItemText
            onClick={() => {
              readNotifications(
                notification.id,
                notification.applicationId,
                notification.controllerLink,
                notification.trackingId,
                notification.notificationMessageId
              );
            }}
            primary={<Typography>{title}</Typography>}
            secondary={
              <>
                <Typography
                  variant="caption"
                  sx={{
                    mt: 0.5,
                    display: 'flex',
                    alignItems: 'center',
                    color: 'text.disabled',
                  }}
                >
                  <Iconify icon="uil:user" sx={{ mr: 0.5, width: 16, height: 16 }} />
                  {noCase('From' + notification.fromUserName)}
                  <Iconify
                    icon="eva:clock-outline"
                    sx={{ ml: 0.5, mr: 0.5, width: 16, height: 16 }}
                  />
                  {fToNow(notification.createdOn)}
                </Typography>
              </>
            }
          />
          <TableMoreMenu
            open={openMenu}
            onOpen={handleOpenMenu}
            onClose={handleCloseMenu}
            actions={
              <>
                <MenuItem onClick={() => readNotification(notification.id)}>
                  <Iconify sx={{ color: 'primary.main' }} icon={'fluent:mail-read-24-regular'} />
                  {isRead === true
                    ? `${translate('CRUD.MarkAsRead')}`
                    : `${translate('CRUD.MarkAsUnread')}`}
                </MenuItem>
              </>
            }
          />
        </ListItemButton>
      </span>
    </>
  );
}

// ----------------------------------------------------------------------

function renderContent(notification: NotificationItemProps) {
  const title = (
    <>
      <Typography fontSize={10} sx={{ fontWeight: 'bold' }}>
        {notification.title + ' ' + notification.trackingNumber}{' '}
      </Typography>
      <Typography component="span" variant="body2" sx={{ color: 'text.secondary' }}>
        &nbsp; {notification.remarks}
      </Typography>
    </>
  );

  // if (notification.title === 'Reception') {
  return {
    avatar: notification.fromUserName ? (
      <Avatar alt={notification.fromUserName} src={baseUrl + notification.fromUserPhotoPath} />
    ) : null,
    title,
  };
  // }
  // return {
  //   avatar: notification.fromUserName ? (
  //     <img
  //       alt={notification.title}
  //       src={baseUrl + notification.fromUserPhotoPath}
  //     />
  //   ) : null,
  //   title,
  // };
}
